import { render, staticRenderFns } from "./StockIndexTable.vue?vue&type=template&id=1aa8109f&"
import script from "./StockIndexTable.vue?vue&type=script&lang=ts&"
export * from "./StockIndexTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports